import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import orderBefore from 'storeCom/order_before'
import orderOld from 'storeCom/order_old'
import order from 'storeCom/order'
import logMoney from 'storeCom/log_money'
import recharge from 'storeCom/recharge'
import sysSetting from 'storeCom/sys/setting'
import sysMessage from 'storeCom/sys/message'
import sysSafe from 'storeCom/sys/safe'

let routes = [
  {path: '/order/before', component: orderBefore},
  {path: '/order/old', component: orderOld},
  {path: '/order/all', component: order},
  {path: '/log/money', component: logMoney},
  {path: '/recharge', component: recharge},
  {path: '/sys/setting', component: sysSetting},
  {path: '/sys/message', component: sysMessage},
  {path: '/sys/safe', component: sysSafe},
  {path: '*', redirect: '/order/before'}
]

export default new Router({
  routes
})


// WEBPACK FOOTER //
// ./src/router/store.js